import React from 'react';

const DeFiVectorEngine = () => {
  return (
    <div className="portfolio-project-page">
      {/* Section for the main content */}
      <div className="project-content-section">
        <h1>DeFi Vector Engine</h1>
        <p>
          ⚠️ This is an ongoing project, and the implementation is not yet fully finalized. You can follow the development on{' '} 
          <a href="https://github.com/MarKuchar/defi-vector-engine" target="_blank" rel="noopener noreferrer">
            GitHub
          </a>.
        </p>
        <p className="projects-intro">
          A fully automated DeFi trading engine leveraging real-time market data, technical indicators, and risk management.
        </p>
        <p>
          The DeFi Vector Engine project demonstrates my expertise in algorithmic trading and web3. The system ingests high-frequency market data, computes technical indicators like RSI, EMA, Bollinger Bands,
          and generates trade signals automatically. It is designed for both backtesting and live trading environments, emphasizing
          modularity, performance, and maintainability.
        </p>
      </div>

      {/* Section for architecture & tech stack */}
      <div className="project-content-section tools-section">
        <h2>💻 Technology Stack & Architecture</h2>
        <p>
          The engine combines backend technologies for real-time performance, automated trading, and risk management.
        </p>

        <h3 className="tools-header">✅ TypeScript & Node.js - Core Logic</h3>
        <p>
          Implemented trading strategies, indicator calculations, and signal generation while ensuring maintainability.
        </p>

        <h3 className="tools-header">✅ WebSockets & REST APIs</h3>
        <p>
          Market data is streamed via WebSockets for low-latency updates. REST APIs are used for order management, user data retrieval,
          and system metrics.
        </p>
      </div>

      {/* Section for trading logic */}
      <div className="project-content-section tools-section">
        <h2>📈 Trading Strategies & Indicators</h2>
        <p>
          The engine supports multiple strategies, with real-time indicator computations and risk management integrated:
        </p>
        <h3>✅ RSI (Relative Strength Index)</h3>
        <p>Generates oversold and overbought signals to detect potential entry and exit points.</p>

        <h3>✅ EMA (Exponential Moving Average) Crossovers</h3>
        <p>
          Detects bullish and bearish trends by comparing short-term and long-term EMAs, triggering trade signals.
        </p>

        <h3>✅ Bollinger Bands</h3>
        <p>
          Monitors price volatility and band touches to indicate possible reversals or momentum continuation.
        </p>

        <h3>✅ Risk Management</h3>
        <p>
          Includes position sizing, stop-loss, take-profit, and circuit breaker mechanisms to protect the portfolio.
        </p>
      </div>

      {/* Section for monitoring & logging */}
      <div className="project-content-section tools-section">
        <h2>🛠 Monitoring & Logging</h2>
        <p>
          Real-time logging, analytics, and health checks are built into the system:
        </p>
        <h3>✅ Console & File Logging</h3>
        <p>
          Tracks trades, signals, and errors in real-time, providing transparency and auditability.
        </p>
      </div>

      {/* Section for data analytics */}
      <div className="project-content-section tools-section">
        <h2>📊 Analytics & Visualization</h2>
        <p>
          The project emphasizes data-driven decisions with historical data analysis.
        </p>
        <h3>⚠️ Price History & Rolling Volume</h3>
        <p>
          Tracks historical prices and rolling 24h volume to support strategy evaluation and trend analysis.
        </p>
        <h3>⚠️ PnL & Equity Monitoring</h3>
        <p>
          Monitors account PnL and equity in real-time, providing actionable insights for strategy refinement.
        </p>
      </div>
    </div>
  );
};

export default DeFiVectorEngine;
